import { RouterProvider, createBrowserRouter } from 'react-router'

import { routes } from './routes.tsx'

const router = createBrowserRouter(routes)

export function AppRouter() {
  return <RouterProvider router={router} />
}
